import { useRef, useEffect } from "react";
import type { AnimationItem } from "lottie-web";

function MapAnimation() {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    let animation: AnimationItem | null = null;
    let cancelled = false;

    // Lazy-load lottie-web so it doesn't bloat the initial JS bundle
    import("lottie-web")
      .then(({ default: lottie }) => {
        if (!containerRef.current || cancelled) return;
        animation = lottie.loadAnimation({
          container: containerRef.current,
          renderer: "svg",
          loop: true,
          autoplay: true,
          path: "/map-animation.json",
        });
      })
      .catch((err) => {
        console.error("Failed to load lottie-web for MapAnimation", err);
      });

    return () => {
      cancelled = true;
      if (animation) {
        animation.destroy();
      }
    };
  }, []);

  return <div ref={containerRef} className="w-full h-full" />;
}

export default MapAnimation;